module.exports = __webpack_public_path__ + "static/media/icon_emh_inactive.83875668.svg";